import type { Injector } from '@angular/core';
import type { MatDialogRef } from '@angular/material/dialog';
import { DIALOG_LIFECYCLE } from '@quipex/core/primitives';
import type { DialogDraftState } from './dialog-draft-state';

export function registerDialogLifecycle<T>(
    ref: MatDialogRef<T>,
    owner: Injector,
    drafts?: DialogDraftState
): void {
    owner.get(
        DIALOG_LIFECYCLE,
        null
    )?.({
        element: ref.componentRef?.location.nativeElement ?? null,
        closed$: ref.afterClosed(),
        close: () => ref.close(),
        hasUnsavedChanges: () => {
            const instance = ref.componentInstance;
            return (
                !!drafts?.hasUnsavedChanges() ||
                (typeof instance === 'object' &&
                    instance !== null &&
                    'hasUnsavedChanges' in instance &&
                    typeof instance.hasUnsavedChanges === 'function' &&
                    instance.hasUnsavedChanges() === true)
            );
        },
    });
}
